//#region Constants
const DEFAULT_PAGE_SIZE = 27;
const MAX_PAGE_COUNT = 200;
const DEFAULT_CLUSTER_DATA_SIZE = 24;
/** from Elasticsearch default max offset (max_result_window) */
const MAX_BOUNDARY_OFFSET = 10000;
//#endregion

export const AREA_PAGE_CONSTANTS = Object.freeze({
  DEFAULT_PAGE_SIZE,
  MAX_PAGE_COUNT,
});

export const MAP_PAGE_CONSTANTS = Object.freeze({
  DEFAULT_CLUSTER_DATA_SIZE,
  MAX_BOUNDARY_OFFSET,
});

export function maxBoundaryPage(pageSize: number): number {
  if (pageSize <= 0) return 1;
  return Math.max(1, Math.floor(MAX_BOUNDARY_OFFSET / pageSize));
}